// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"1d45c744","94":"81ef2809","120":"9c859d09","126":"5287134d","171":"4f506a61","407":"3c42cb75","432":"603b252c","532":"234acb63","674":"746419fe","684":"b5afe3c1","711":"3478d314","744":"966c2029","994":"19acdefa"}[chunkId] + ".chunk.js";
};